import { cache } from '@cornerstonejs/core';
import { utilities } from '@cornerstonejs/metadata';
import dataSetCacheManager from './wadouri/dataSetCacheManager';
import wadorsMetaDataManager from './wadors/metaDataManager';
import wadouriRegister from './wadouri/register';
import wadorsRegister from './wadors/register';
function registerLoaders(options) {
    cache.purgeCache();
    dataSetCacheManager.purge();
    wadorsMetaDataManager.purge();
    utilities.clearCacheData();
    wadorsRegister(options);
    wadouriRegister(options);
}
export default registerLoaders;
